<script>
import { createBrand, updateBrand } from '@/utils/brands'

export default {
    inject: ['setLoading'],

    data() {
        return {
            id: null,
            name: '',
            errors: {}
        }
    },

    methods: {

        open(row = null) {
            this.reset()

            if (!row) return

            this.id = row.id
            this.name = row.name
        },

        async save() {
            this.errors = {}
            this.setLoading(true)

            try {

                const payload = {
                    name: this.name
                }

                let response

                if (this.id) {
                    response = await updateBrand(this.id, payload)
                } else {
                    response = await createBrand(payload)
                }

                this.$swalToast(response.data.message)

                this.$emit('updated')
                this.$closeModal('brand_modal')

                this.reset()

            } catch (error) {

                if (error.type === 'validation') {
                    this.errors = error.errors
                } else {
                    this.$swalToast(error.message, 'error')
                }

            } finally {
                this.setLoading(false)
            }
        },

        reset() {
            this.id = null
            this.name = ''
            this.errors = {}
        }

    }
}
</script>


<template>

    <div class="modal fade" id="brand_modal">

        <div class="modal-dialog modal-dialog-centered">

            <div class="modal-content">

                <div class="modal-header">

                    <h4 class="modal-title">
                        {{ id ? 'Edit Brand' : 'Add Brand' }}
                    </h4>

                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>

                </div>

                <form @submit.prevent="save">

                    <div class="modal-body">

                        <div class="mb-3">

                            <label class="form-label">Name</label>

                            <input type="text" class="form-control" v-model="name" />

                            <div v-if="errors.name" class="text-danger small">
                                {{ errors.name[0] }}
                            </div>

                        </div>

                    </div>

                    <div class="modal-footer">

                        <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                            Cancel
                        </button>

                        <button type="submit" class="btn btn-primary">
                            Save
                        </button>

                    </div>

                </form>

            </div>

        </div>

    </div>

</template>